import React, { PureComponent } from 'react';
import { cloneDeep } from 'lodash';
import { injectIntl } from 'react-intl';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Icon,
  Input,
  MenuItem,
  Select,
  Slide
} from '@material-ui/core';
import { sortBy, uniqWith, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { isEmail } from '../../../../../../utils/utils';
import { APPROVAL_LEVELS } from '../../../../../../utils/util-constants';

const EMPTY_CONTACT = (props) => ({
  placeholder: true,
  contactPersonName: props.intl.formatMessage({ id: 'select_contact' })
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class DialogApprovalRequired extends PureComponent {
  constructor(props) {
    super(props);
    const customerContacts = !!props.data.customer.customerContacts
      ? props.data.customer.customerContacts
      : [];

    const contactOptions = [EMPTY_CONTACT(props), ...customerContacts];
    const foundIndex = contactOptions.findIndex(
      (contact) =>
        contact.contactPersonName === props.data.renewal.customerApproverName
    );

    const selectedContactIndex = foundIndex > 0 ? foundIndex : 0;

    this.state = {
      contactOptions,
      selectedContactIndex,
      customerApproverName: '',
      customerEmail: '',
      dialogOpen: this.props.open
    };

    this.onSelectChange = this.onSelectChange.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onSelectChange(selectedContactIndex) {
    this.setState(
      {
        selectedContactIndex
      },
      () => {
        const contact =
          this.state.contactOptions[this.state.selectedContactIndex];

        const updatedRenewal = contact.placeholder
          ? {
              ...cloneDeep(this.props.data.renewal),
              customerApproverName: '',
              customerEmail: ''
            }
          : {
              ...cloneDeep(this.props.data.renewal),
              customerApproverName: contact.contactPersonName,
              customerEmail: contact.contactPersonEmail
            };
        this.props.data.updateRenewal(updatedRenewal, false);
      }
    );
  }

  onChangeName(customerApproverName) {
    this.props.data.updateRenewal(
      {
        ...cloneDeep(this.props.data.renewal),
        customerApproverName
      },
      false
    );
  }

  onChangeEmail(customerEmail) {
    this.props.data.updateRenewal(
      {
        ...cloneDeep(this.props.data.renewal),
        customerEmail
      },
      false
    );
  }

  onBlur() {
    this.props.data.updateRenewal(this.props.data.renewal, false);
  }

  render() {
    const lineItems = this.props.data.renewal.lineItems;
    const newEasyCareItems = lineItems.filter(i => i.newImageCare === true).flatMap(({
                                                                                       itemName,
                                                                                       newImageCare,
                                                                                       itemCode,
                                                                                       size
                                                                                     }) => {
      return [{
        itemName: itemName,
        newImageCare: newImageCare,
        itemCode: itemCode,
        size: size
      }
      ]
    })
    const list = [];
    var productInfo = '';
    for (let i in newEasyCareItems) {
      if(newEasyCareItems[i].newImageCare === true){
        productInfo = newEasyCareItems[i].itemName + '                  ' + newEasyCareItems[i].itemCode + '              ' + newEasyCareItems[i].size;
        list.push(productInfo);
      }
    }

    const validations = uniqWith(
      sortBy(this.props.data.validations, ['category', 'itemCode']),
      isEqual
    );

    const tier1Validations = validations.filter(
      (validation) =>
        validation.validityLevel === APPROVAL_LEVELS.TIER1_APPROVAL
    );
    const tier2Validations = validations.filter(
      (validation) =>
        validation.validityLevel === APPROVAL_LEVELS.TIER2_APPROVAL
    );
    const tier3Validations = validations.filter(
      (validation) =>
        validation.validityLevel === APPROVAL_LEVELS.TIER3_APPROVAL
    );
    return (
      <Dialog
        aria-labelledby="approval-required-title"
        aria-describedby="approval-required-description"
        open={this.props.open}
        onClose={() => this.props.onClose(true)}
        TransitionComponent={Transition}
        className="dialog-wrapper"
      >
        <DialogContent>
          {list.length > 0 &&
            <DialogTitle id="signature-required-title" className="dialog-title">
              {this.props.intl.formatMessage({
                id: 'easy_care_conversion'
              })}
            </DialogTitle>}

          {list.length > 0 &&
            <DialogContent>
              <div>
                <p style={{ textJustify: "inter-word" }}>During the renewal based on company standards, the below products have either been converted from our legacy Inventory Maintenance to EasyCare, or have been enrolled in EasyCare:</p><br />
                {list.map(filteredName => (
                  <li>
                    {filteredName}
                  </li>
                ))}
              </div>
            </DialogContent>}
          <DialogTitle id="approval-required-title" className="dialog-title">
            {this.props.intl.formatMessage({
              id: 'requiring_approval.title'
            })}
          </DialogTitle>
          <p id="approval-required-description" className="dialog-text">
            {' '}
            {this.props.intl.formatMessage({
              id: 'Dialog_para'
            })}
          </p>
          <div className="dialog-subheader">
            {' '}
            {this.props.intl.formatMessage({
              id: 'reason_for_approval'
            })}
          </div>
          <hr />
          <ul>
            {validations.map((validation, index) => (
              <li key={index}>{validation.message}</li>
            ))}
          </ul>
{/*
          <ul>
            {!!tier1Validations && !!tier1Validations.length ? (
              <li>
                {this.props.intl.formatMessage({
                  id: 'tier1_approval'
                })}
                <ul>
                  {tier1Validations.map((validation, index) => (
                    <li key={index}>{validation.message}</li>
                  ))}
                </ul>
              </li>
            ) : null}
            {!!tier2Validations && !!tier2Validations.length ? (
              <li>
                {this.props.intl.formatMessage({
                  id: 'tier2_approval'
                })}
                <ul>
                  {tier2Validations.map((validation, index) => (
                    <li key={index}>{validation.message}</li>
                  ))}
                </ul>
              </li>
            ) : null}
            {!!tier3Validations && !!tier3Validations.length ? (
              <li>
                {this.props.intl.formatMessage({
                  id: 'tier3_approval'
                })}
                <ul>
                  {tier3Validations.map((validation, index) => (
                    <li key={index}>{validation.message}</li>
                  ))}
                </ul>
              </li>
            ) : null}
          </ul>
*/}
          {!this.props.hideAccept ? (
            <>
              <FormControl className="approval-contact expand-field-width">
                <label
                  className="dialog-subheader"
                  htmlFor="approval-contact-select"
                >
                  {this.props.intl.formatMessage({
                    id: 'approval_contact'
                  })}
                </label>
                <Select
                  value={this.state.selectedContactIndex}
                  onChange={(event) => this.onSelectChange(event.target.value)}
                  inputProps={{
                    name: 'approval-contact',
                    id: 'approval-contact-select'
                  }}
                >
                  {this.state.contactOptions.map((contact, index) => (
                    <MenuItem key={index} value={index}>
                      {contact.contactPersonName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl className="text-input-field expand-field-width">
                <label
                  className="dialog-subheader"
                  htmlFor="contact-name-field"
                >
                  {this.props.intl.formatMessage({
                    id: 'contact_first_and_last_name'
                  })}
                </label>
                <Input
                  id="contact-name-field"
                  value={this.props.data.renewal.customerApproverName || ''}
                  onChange={(event) => this.onChangeName(event.target.value)}
                  onBlur={this.onBlur}
                />
              </FormControl>
              <FormControl className="text-input-field expand-field-width">
                <label
                  className="dialog-subheader"
                  htmlFor="contact-email-field"
                >
                  {this.props.intl.formatMessage({
                    id: 'contact_email'
                  })}
                </label>
                <Input
                  id="contact-email-field"
                  value={this.props.data.renewal.customerEmail || ''}
                  onChange={(event) => this.onChangeEmail(event.target.value)}
                  onBlur={this.onBlur}
                />
              </FormControl>{' '}
            </>
          ) : null}
        </DialogContent>
        <DialogActions className="dialog-action-buttons">
          <span className="btn-secondary-action">
            <Button onClick={this.props.onClose} color="primary">
              {this.props.intl.formatMessage({
                id: 'cancel'
              })}
            </Button>
          </span>
          {!this.props.hideAccept ? (
            <span className="btn-action">
              <Button
                onClick={this.props.onAccept}
                color="primary"
                disabled={
                  this.props.data.renewal.customerApproverName == null ||
                  this.props.data.renewal.customerApproverName === '' ||
                  !isEmail(this.props.data.renewal.customerEmail)
                }
              >
                {this.props.intl.formatMessage({
                  id: 'submit_for_approval'
                })}

                <Icon>chevron_right</Icon>
              </Button>
            </span>
          ) : null}
        </DialogActions>
      </Dialog>
    );
  }
}

DialogApprovalRequired.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func,
  hideAccept: PropTypes.bool,
  data: PropTypes.object
};

export default injectIntl(DialogApprovalRequired);
